import React, { useEffect, useState } from "react";

import lbl from "../../data/Labels.json";
import ArrowIcon from "../../icons/arrow-icon";

const Select = ({ options, error, name, value: cache, passValue, disabled }) => {
  const [query, setQuery] = useState("");
  const [visible, setVisible] = useState("");
  const [filter, toggleFilter] = useState(false);

  const inputAttr = {
    className: error && "error",
    autoComplete: "off",
    value: query,
    type: "text",
  };

  const renderDropDownIcon = () => {
    return (
      <i className={visible ? "open" : ""} onClick={() => !disabled ? setVisible(!visible): null}>
        <ArrowIcon />
      </i>
    );
  };

  const renderDropDownItems = () => {
    let data = options;

    if (filter && query) {
      data = options.filter(({ name }) =>
        name.toLowerCase().includes(query.toLowerCase())
      );
    }

    return (
      visible && (
        <ul>
          {data &&
            (data.length > 0 ? (
              data.map((item) => (
                <li
                  onClick={() => selectItem(item)}
                  value={item.id}
                  key={item.id == null ? `${name}-none` : item.id}
                >
                  {item.name}
                </li>
              ))
            ) : (
              <li>{lbl.RecordNotFound}</li>
            ))}
        </ul>
      )
    );
  };

  const selectItem = (data) => {
    passValue({ name, data });
    setQuery(data.name);
    toggleFilter(false);
    setVisible(false);
  };

  const handleChange = ({ target }) => {
    setVisible(target.value);
    setQuery(target.value);
    toggleFilter(true);
  };

  useEffect(() => {
    if (cache === null || cache === undefined || cache === "") {
      setQuery("");
      return;
    }
    let data = (options || []).filter(
      (item) => item.id === cache || item.name === cache
    );
    setQuery(data[0]?.name || "");
  }, [cache, options]);

  return (
    <div className="custom-select">
      <input
        disabled={disabled}
        onClick={(e) => setVisible(!e.target.value)}
        onFocus={(e) => setVisible(!e.target.value)}
        onChange={(e) => handleChange(e)}
        {...inputAttr}
      />
      {renderDropDownIcon()}
      {renderDropDownItems()}
    </div>
  );
};

export default Select;
